import { API_URL } from "../constants.js";
import axios from 'axios';
import middleware from '../util/middleware';

var request = axios.create({
    baseURL: API_URL,
    headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json'
    }
})

/**
 * Clase para ver el request de categorías
 */
class CategoriasRequest {
    /**
     * Llamada el endpoint de django para obtener los artículos
     * en la BD
     * @param: nada
     * @return: Una lista de artículos.
     */
    static ListarCategorias(valor) {
        return middleware.hasAuth(() => request.get(`api/categorias/`, {
            params: {
                todos: valor
            }
        }))
    }

    /**
     * Llamada el endpoint de django para obtener los artículos
     * en la BD
     * @param: value. id del modelo
     * @return: Una lista de artículos.
     */
    static ListarCategoriasModelo(value) {
        return middleware.hasAuth(() => request.get(`api/categorias/?tipo_modelo=${value}`))
    }

    /**
     * Llamada el endpoint de django para crear / editar una categoría
     * @param: value. id de la categoría
     * @param: data. objeto con información de la categoría
     * @return: Mensaje de éxito o error.
     */
    static EditarCategoria(value, data) {
        if (value === null) {
            return middleware.hasAuth(() => request.post(`api/categorias/`, data));
        } else {
            return middleware.hasAuth(() => request.put(`api/categorias/${value}/`, data));
        }

    }

    /**
     * Llamada el endpoint de django para crear una categoría
     * @param: data. objeto con información de la categoría
     * @return: Mensaje de éxito o error.
     */
    static CrearCategoriaCalendario(data) {
        return middleware.hasAuth(() => request.post(`api/categorias/calendario/`, data));
    }

    /**
     * Llamada el endpoint de django para editar una categoría
     * @param: value. id de la categoría calendario
     * @param: data. objeto con información de la categoría
     * @return: Mensaje de éxito o error.
     */
    static EditarCategoriaCalendario(value, data) {
        return middleware.hasAuth(() => request.put(`api/categorias/calendario/${value}`, data));
    }

    /**
     * Llamada el endpoint de django para listar categorías calendario
     * @param: data. objeto con arreglo de sitios
     * @return: Mensaje de éxito o error.
     */
    static ListarCategoriaCalendario(data) {
        return middleware.hasAuth(() => request.post(`api/categorias/calendario/detalle/`, data));
    }

    /**
     * Llamada el endpoint de django para eliminar categoría calendario
     * @param: value. id de la categoría calendario
     * @return: Mensaje de éxito o error.
     */
    static EliminarCategoriaCalendario(value) {
        return middleware.hasAuth(() => request.delete(`api/categorias/calendario/delete/${value}/`));
    }

    /**
     * Llamada el endpoint de django para eliminar categoría
     * @param: value. id de la categoría
     * @return: Mensaje de éxito o error.
     */
    static EliminarCategoria(value) {
        return middleware.hasAuth(() => request.put(`api/categorias/delete/${value}/`));
    }
}

export default CategoriasRequest;